<template lang="pug">
  .progress-indicator(:class="`progress-indicator--${ size }`")
    template(v-if="type === 'bar'")
      span.progress-rect.bar(
        v-for="i in 5"
        :key="i"
        :class="i <= value && 'filled'"
      )

    template(v-else)
      span.progress-rect(
        v-for="i in 5"
        :key="i"
        :class="i <= value && 'filled'"
      ) €

</template>

<script>
export default {
  name: 'progress-indicator',

  props: {
    value: {
      type: Number,
      default: 0
    },

    size: {
      type: String,
      default: 'lg'
    },

    type: {
      type: String,
      default: 'bar' // 'bar', 'euro'
    }
  }
};
</script>

<style lang="scss">
.progress-indicator {
  display: flex;

  .progress-rect {
    display: inline-block;
    color: #CEA2C7;
    font-size: 20px;
    font-weight: bold;
    line-height: 1;
    width: 16px;
    height: 18px;
    margin: 0 1px;

    &.filled {
      color: #861773;
    }

    &.bar {
      background-color: #CEA2C7;
      width: 18px;

      &.filled {
        background-color: #861773;
      }
    }
  }

  &--sm {
    .progress-rect {
      font-size: 12px;
      line-height: 1;
      width: 10px;
      height: 12px;

      &.bar {
        width: 10px;
      }
    }
  }

  &.fsoel {
    .progress-rect {
      color: #d8a8b1;

      &.filled {
        color: #9d253c;
      }

      &.bar {
        background-color: #d8a8b1;

        &.filled {
          background-color: #9d253c;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/apps/risiko_check/progress-indicator.vue